import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-participant-notes',
  templateUrl: './participant-notes.component.html',
  styleUrls: ['./participant-notes.component.scss']
})
export class ParticipantNotesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
